import React, { useEffect } from "react";
import useEventCallback from "./useEventCallback";
const FORCE_CLEAR_TIMEOUT = 600;
export const useRippleController = (handlers, options) => {
    var _a;
    const rippleRef = React.useRef(null);
    const disableTouchRipple = (_a = options === null || options === void 0 ? void 0 : options.disableTouchRipple) !== null && _a !== void 0 ? _a : false;
    const forceClearRippleTimer = React.useRef(null);
    const delayedStopEventTimer = React.useRef(null);
    function forceClearRipple() {
        var _a;
        forceClearRippleTimer.current = null;
        (_a = rippleRef.current) === null || _a === void 0 ? void 0 : _a.forceClear();
    }
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return useEventCallback((event) => {
            if (eventCallback) {
                eventCallback(event);
            }
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) {
                if (rippleAction == "start") {
                    if (forceClearRippleTimer.current != null)
                        clearTimeout(forceClearRippleTimer.current);
                    forceClearRippleTimer.current = setTimeout(forceClearRipple, FORCE_CLEAR_TIMEOUT);
                    rippleRef.current["start"](event);
                }
                else if (rippleAction == "pulsate")
                    rippleRef.current["pulsate"](event);
                else {
                    if (delayedStopEventTimer.current != null)
                        clearTimeout(delayedStopEventTimer.current);
                    delayedStopEventTimer.current = setTimeout(() => {
                        var _a;
                        (_a = rippleRef.current) === null || _a === void 0 ? void 0 : _a["stop"](event);
                    }, FORCE_CLEAR_TIMEOUT);
                }
            }
            return true;
        });
    }
    const { onMouseDown: onMouseDownHandler, onContextMenu: onContextMenuHandler, onDragLeave: onDragLeaveHandler, onMouseUp: onMouseUpHandler, onMouseLeave: onMouseLeaveHandler, onTouchStart: onTouchStartHandler, onTouchEnd: onTouchEndHandler, onTouchMove: onTouchMoveHandler, onBlur: onBlurHandler, } = handlers;
    const onMouseDown = useRippleHandler("start", onMouseDownHandler);
    const onContextMenu = useRippleHandler("stop", onContextMenuHandler);
    const onDragLeave = useRippleHandler("stop", onDragLeaveHandler);
    const onMouseUp = useRippleHandler("stop", onMouseUpHandler);
    const onMouseLeave = useRippleHandler("stop", onMouseLeaveHandler);
    const onTouchStart = useRippleHandler("start", onTouchStartHandler);
    const onTouchEnd = useRippleHandler("stop", onTouchEndHandler);
    const onTouchMove = useRippleHandler("stop", onTouchMoveHandler);
    const onBlur = useRippleHandler("stop", onBlurHandler, false);
    useEffect(() => {
        return () => {
            if (forceClearRippleTimer.current != null)
                clearTimeout(forceClearRippleTimer.current);
            if (delayedStopEventTimer.current != null)
                clearTimeout(delayedStopEventTimer.current);
        };
    }, []);
    return {
        rippleRef,
        onMouseDown,
        onContextMenu,
        onDragLeave,
        onMouseUp,
        onMouseLeave,
        onTouchStart,
        onTouchEnd,
        onTouchMove,
        onBlur,
    };
};
//# sourceMappingURL=useRippleController.js.map